import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CreateContractComponent} from '../../shared/create-contract/create-contract.component';
import {CreateProgramComponent} from '../../shared/create-program/create-program.component';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {Router} from '@angular/router';
import {ContractSelectorStateService} from "../../shared/contract-selector-state-service/contract-selector-state.service";
import {Cedant, Contract, Program} from "../../shared/shared.types";


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

    @Output()
    toggleNotificationSidenav   = new EventEmitter<void>();
    isNotificationActive        = false;
    tab = 2;
    @Input()
    ishome: boolean;
    selectedProgram:  Program  = null;
    selectedCedant:   Cedant   = null;
    selectedContract: Contract = null;

    constructor(
        private dialog: MatDialog,
        public router: Router,
        private contractSelectorState: ContractSelectorStateService
    ) {
    }


  ngOnInit() {
    this.contractSelectorState
      .cedant$.subscribe( c => {
      this.selectedCedant = c;
    });
    this.contractSelectorState
      .program$.subscribe( p => {
      this.selectedProgram = p;
    });
    this.contractSelectorState
      .contract$.subscribe( c => {
      this.selectedContract = c;
    });
  }

    onCreateContract() {
        const config = new MatDialogConfig();
        config.data = {title: 'Create Contract'};
        config.minHeight = '400px';
        config.width = '800px';
        config.panelClass = 'create-contract';

        const dialogRef = this.dialog.open(CreateContractComponent, config);

        dialogRef.afterClosed().subscribe(result => {
            if (result.isOk) {
                this.router.navigate(['/cedant/1/program/1/contract/0']);
            }
        });
    }

    onCreateProgram() {
        const config = new MatDialogConfig();
        config.data = {title: 'Create Program'};
        config.minHeight = '400px';
        config.width = '640px';
        config.panelClass = 'create-program';

        const dialogRef = this.dialog.open(CreateProgramComponent, config);
    }

    selectTab(value) {
        this.tab = value;
    }

}
